import {Card, CardProps, useTheme} from '@mui/material';
import {useConfigurationInRedux} from 'hooks';
import React from 'react';
export interface AppCardProps extends CardProps {
    border?: boolean;
    boxShadow?: boolean;
    shadow?: string;
    elevation?: number;
    codeHighlight?: boolean;
    paddingBottom?: number | string;
    hoverEffect?: boolean;
}
export const AppCard: React.FC<AppCardProps> = ({
    children,
    border = true,
    boxShadow,
    shadow,
    codeHighlight,
    elevation,
    hoverEffect = false,
    sx,
    ...rest
}) => {
    const theme = useTheme();
    const {themeContrast} = useConfigurationInRedux();
    return (
        <Card
            elevation={elevation || 0}
            {...rest}
            sx={{
                padding: '10px',
                position: 'relative',
                border: border ? '1px solid' : 'none',
                borderRadius: '12px',
                borderColor: theme.palette.divider,
                ...(((themeContrast && boxShadow) || shadow) && {
                    boxShadow: shadow ? shadow : theme.customShadows.z1,
                }),
                ...(hoverEffect && {
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    '&:hover': {
                        boxShadow: 3,
                        transform: 'translateY(-2px)',
                        cursor: 'pointer',
                    },
                }),
                ...sx,
                ...(codeHighlight && {
                    '& pre': {
                        m: 0,
                        p: '12px !important',
                        fontFamily: theme.typography.fontFamily,
                        fontSize: '0.75rem',
                    },
                }),
            }}
        >
            {children}
        </Card>
    );
};

export default AppCard;
